const NOT_STARTED = {
  label: "Not Started",
  classes: "bg-blue-50 text-blue-600 border-blue-100",
  dot: "bg-blue-500",
};
const IN_PROGRESS = {
  label: "In Progress",
  classes: "bg-orange-50 text-orange-600 border-orange-100",
  dot: "bg-orange-500",
};
const COMPLETED = {
  label: "Completed",
  classes: "bg-emerald-50 text-emerald-600 border-emerald-100",
  dot: "bg-emerald-500",
};

// Returns the progress badge for a video given the user's last saved
// position. Both `savedTime` and `video.videoLength` are coerced to
// numbers because either may arrive as a string from the API or as
// `undefined` for a row that was created before its YouTube metadata
// resolved (see PR-D handleSave). A zero or non-finite videoLength
// would otherwise let `savedTime >= -2` mark every row as Completed.
const getProgressData = (savedTime, video) => {
  const saved = Number(savedTime);
  const length = Number(video?.videoLength);
  const hasValidLength = Number.isFinite(length) && length > 0;
  const hasProgress = Number.isFinite(saved) && saved > 0;

  if (!hasProgress) return NOT_STARTED;
  if (hasValidLength && saved >= length - 2) return COMPLETED;
  return IN_PROGRESS;
};

export default getProgressData;
